























































import { Component, Vue } from "vue-property-decorator";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import SEP from "@/services/bridgingVclaim/SEP";
import moment from "moment";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import { appModule } from "@/store/modules/app";
// import UpdateTanggalPulangModal from "./UpdateTanggalPulangModal.vue";

@Component({
  components: {
    ModalKonfirmasi
    // UpdateTanggalPulangModal
  }
})
export default class RiwayatSEP extends Vue {
  today = new Date().toISOString().substr(0, 10);
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  noSEP = "";
  noKartu = "";

  deleting = false;
  // showTglPulangModal = false;

  get headers() {
    const head = [
      {
        text: "Nomor SEP",
        value: "noSep",
        width: "20vh",
        align: "left"
      },
      {
        text: "Tgl SEP",
        filterable: false,
        value: "tgl",
        width: "10vh",
        align: "left"
      },
      {
        text: "Poli",
        filterable: false,
        value: "poli",
        align: "left"
      },
      {
        text: "No Rujukan",
        filterable: false,
        value: "noRujukan",
        width: "20vh",
        align: "left"
      },
      {
        text: "Aksi",
        filterable: false,
        value: "aksi",
        width: "22vh",
        align: "center"
      }
    ];
    return head;
  }

  get riwayatSEP() {
    return storeSEP.riwayatSEP;
  }

  get sep() {
    return storeSEP.sep;
  }

  get loading() {
    return storeSEP.loading;
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD-MM-YYYY") : "";
  }

  cetak(noSep) {
    SEP.print(noSep);
  }

  edit(noSep) {
    storeSEP.act_get_sep(noSep);
  }

  hapus() {
    const dt = {
      request: {
        t_sep: {
          noSep: this.noSEP,
          user: "Coba Ws"
        }
      }
    };
    if (!this.deleting) {
      this.deleting = true;
      SEP.hapus(dt)
        .then(resp => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            appModule.NoticeDelay("Berhasil Menghapus SEP");
            const param = {
              nomor: this.noKartu,
              tgl_awal: "2022-01-01",
              tgl_akhir: this.today
            };
            storeSEP.act_riwayat_sep(param);
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }

  konfirmHapus(sep, kartu) {
    this.noSEP = sep;
    this.noKartu = kartu;
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = "Anda yakin ingin menghapus SEP dengan no: " + sep;
  }

  klikRow(item) {
    storeSEP.act_get_sep(item.noSep);
  }
}
